"use client";
import React, { useEffect } from "react";
import { languageIds } from "@/lib/language";
import { useXNoticeStore } from "@/components/context/xnotice-store";
import { usePathname } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "@/utils/request";
const XNoticeSetter: React.FC<{ lang: string }> = ({ lang }) => {
  const {
    addNotice,
    clearNotices,
    cartCategories,
    categories,
    cartProducts,
    product,
    manufacturer,
  } = useXNoticeStore();
  const pathname = usePathname();
  const { data } = useQuery({
    queryKey: ["xNotice"],
    queryFn: () => getRequest({ path: { name: "xNotice" }, lang, skipCache: true }),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 0,
  });

  function validate(notice: any) {
    let valid = !!notice.notice[languageIds[lang]];
    if (notice.rules.route) {
      const path = pathname.replace(`/${lang}`, "");
      const routes = notice.rules.route.value.split(",");
      const normalizePath = (str: string) => str.trim().replace(/^\/+|\/+$/g, "");
      valid = valid && routes.some((item: string) => normalizePath(item) === normalizePath(path));
    }
    if (notice.rules.page) {
      let path = pathname.replace(`/${lang}`, "").replace(/^\/+|\/+$/g, "");
      if (!path) {
        path = "homepage";
      }
      valid = valid && notice.rules.page.value.some((item: string) => path.startsWith(item));
    }
    if (notice.rules.date) {
      const today = new Date();

      const startDate = new Date(notice.rules.date.start);
      const endDate = new Date(notice.rules.date.end);
      valid = valid && today >= startDate && today <= endDate;
    }
    if (notice.product_src == "route") {
      if (notice.rules.category) {
        valid =
          valid &&
          validateArray(notice.rules.category.value, categories, notice.rules.category.rule_type);
      }
      if (notice.rules.product) {
        valid =
          valid &&
          validateArray(notice.rules.product.value, [product], notice.rules.product.rule_type);
      }
    } else {
      if (notice.rules.category) {
        valid =
          valid &&
          validateArray(notice.rules.category.value, categories, notice.rules.category.rule_type) &&
          validateArray(
            notice.rules.category.value,
            cartCategories,
            notice.rules.category.rule_type,
          );
      }
      if (notice.rules.product) {
        valid =
          valid &&
          validateArray(notice.rules.product.value, [product], notice.rules.product.rule_type) &&
          validateArray(notice.rules.product.value, cartProducts, notice.rules.product.rule_type);
      }
    }

    if (notice.rules.manufacturer) {
      valid =
        valid &&
        validateArray(
          notice.rules.manufacturer.value,
          [manufacturer],
          notice.rules.manufacturer.rule_type,
        );
    }
    // const routes = [
    //   "home",
    //   "product",
    //   "listing",
    //   "checkout",
    //   "cart",
    //   "account",
    //   "information",
    //   "contact",
    //   "other",
    // ];
    return valid;
  }
  function validateArray(arrayBase: string[], arrayCompare: string[], rule_type: string) {
    let valid = true;
    switch (String(rule_type)) {
      case "3":
      case "6":
        valid = arrayBase.some((item: string) => arrayCompare.includes(item));
        break;
      case "4":
      case "2":
        valid = arrayBase.every((item: string) => arrayCompare.includes(item));
        break;
      case "5":
      case "7":
        valid = arrayBase.every((item: string) => !arrayCompare.includes(item));
        break;
    }
    return valid;
  }
  useEffect(() => {
    clearNotices();
    if (data?.data) {
      Object.values(data.data.xmethods).forEach((notice: any) => {
        if (validate(notice)) {
          addNotice({
            selector: notice.setting.selector,
            html: notice.notice[languageIds[lang]],
            settings: notice.setting,
            rules: notice.rules,
            theme: notice.theme,
            id: String(notice.tab_id),
          });
        }
      });
    }
  }, [data, cartCategories, categories, cartProducts, product]);

  return <></>;
};
export default XNoticeSetter;
